import { useState } from 'react';
import styled, { css } from 'styled-components';
import toast from 'react-hot-toast';
import Api from '../utils/Api';
import SelectUser from './SelectUser';
import UserCard from './UserCard';

const shareWithUserStyles = css`
display: flex;
flex-direction: column;
gap: 10px;
text-align: center;
width: 100%;
 & .user {
  display: flex;
  font-weight: bold;
  flex-wrap: wrap;
  justify-content: space-between;
 }
 & .select-user {
    display: flex;
    flex-direction: column;
    gap: 10px;
    > .title {
      font-weight: bold;
    }
  }
  & .buttons {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: flex-end;
  }
`;

const ShareWithUser = styled(({ className, listId, groupId, onShared }) => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [shareWithEmail, setShareWithEmail] = useState('');
  const [shareWithFirstname, setShareWithFirstName] = useState('');
  const [shareWithLastName, setShareWithLastname] = useState('');
  const isShareDisabled = (!(shareWithEmail && shareWithFirstname && shareWithLastName));

  const handleSelectUser = user => {
    setSelectedUser(user);
    setShareWithEmail(user?.email ?? '');
    setShareWithFirstName(user?.firstname ?? '');
    setShareWithLastname(user?.lastname ?? '');
  }

  const handleShareWithUser = async user => {
    const { email, firstname, lastname } = user;
    const [error,] = await Api.shareWithUser({ email, firstname, lastname, listId, groupId });
    if (error) {
      console.error(error);
      return toast.error(Api.error(error));
    } else {
      toast.success('List has been shared');
      clear();
      onShared();
    }
  }

  const clear = () => {
    setSelectedUser(null);
    setShareWithEmail('');
    setShareWithFirstName('');
    setShareWithLastname('');
  }

  return (
    <div className={className}>
      <div className='select-user'>
        {
          selectedUser
            ? <UserCard className = 'selected' user = {selectedUser}/>
            :
            <>
              <div className = 'title'>Find an existing user by name or email</div>
              <SelectUser placeholder = 'Share with (name or email)' onSelect={handleSelectUser} />
              <div className = 'title'>Or, invite a new user</div>
              <input disabled={selectedUser} value={shareWithFirstname} placeholder='First name' onChange={e => setShareWithFirstName(e.target.value)} />
              <input disabled={selectedUser} value={shareWithLastName} placeholder='Last name' onChange={e => setShareWithLastname(e.target.value)} />
              <input disabled={selectedUser} value={shareWithEmail} placeholder='Email' onChange={e => setShareWithEmail(e.target.value)} />
            </>
        }

      </div>
      <div className='buttons'>
        {!isShareDisabled && <button className='danger' onClick={clear}>Cancel</button>}
        <button className='primary' disabled={isShareDisabled} onClick={() => handleShareWithUser({
          firstname: shareWithFirstname,
          lastname: shareWithLastName,
          email: shareWithEmail
        })}>Share</button>
      </div>
    </div>
  )
})`${shareWithUserStyles}`;

export default ShareWithUser;